<template>
  <div
    component-name="table-format-tickness"
    class="overflow-x-auto max-w-full flex flex-col gap-md"
  >
    <table class="overflow-hidden table-auto w-full">
      <thead v-if="thead?.length" class="w-full">
        <tr class="h-16">
          <th
            v-for="(th, index) in thead"
            class="px-sm border-b border-b-current"
            :class="{
              'text-body px-md text-left': index === 0,
              'text-body-small text-center': index > 0,
            }"
          >
            <wrapper-reveal tag="span" reveal="fade-from-0">
              <span class="whitespace-nowrap" v-html="th"></span>
            </wrapper-reveal>
          </th>
        </tr>
      </thead>
      <tbody v-if="tbody?.length" class="w-full">
        <tr v-for="tr in tbody" class="h-16">
          <td
            class="whitespace-nowrap px-sm border-b border-b-current"
            v-for="(td, i) in tr"
          >
            <wrapper-reveal v-if="i === 0" reveal="fade-from-right">
              <span v-html="td" class="block text-body/none px-xl"></span>
            </wrapper-reveal>

            <span
              v-else
              class="block text-center align-middle"
              :class="{
                invisible: !td,
              }"
            >
              <svg-icon
                v-if="td === 'resource'"
                size="big"
                icon="resource"
                class="mx-auto text-resource"
              />
              <span v-else class="text-[50px]/none select-none">&bull;</span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <ul v-if="useReSource" class="list-none flex flex-col items-end">
      <li class="flex items-center gap-xs">
        <svg-icon size="big" icon="resource" style="color: #348364" />
        <span class="block text-body-small/none translate-y-px">{{
          $t.texts.resource_table_legend
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  thead: {
    type: Array,
    required: false,
  },
  tbody: {
    type: Array,
    required: false,
  },
});

const useReSource = computed(() => {
  if (props.tbody) {
    return props.tbody.some((tr) => tr.includes("resource"));
  }
  return false;
});
</script>
